import { combineEpics } from 'redux-observable'
import { loadCryptoCurrenciesMarketDataEpic } from 'components/features/rewards/rewardsPane/store/epics/common/cryptoCurrenciesMarketData'
import { loadCryptoCurrenciesMetaInfoEpic } from 'components/features/rewards/rewardsPane/store/epics/common/cryptoCurrenciesMeta'
import { disableAutoinvestmentsModeEpic } from 'components/features/rewards/rewardsPane/store/epics/common/disableAutoinvestmentsMode'

export const cryptoRewardsEpicCommon = combineEpics(
  loadCryptoCurrenciesMetaInfoEpic,
  loadCryptoCurrenciesMarketDataEpic,
  disableAutoinvestmentsModeEpic,
)
